import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@material-ui/core';
import { useFormikContext } from 'formik';

import {
  ClientDepartmentFragment,
  UpdateUserSegmentInput,
  UserSegmentFragment,
  useUpdateUserSegmentMutation,
} from 'api';
import { DepartmentPicker } from 'components/Pickers';
import { useUpdateSegment } from 'features/admin/updaters';

interface IProps {
  segment: UserSegmentFragment;
  onSave: () => void;
}

const DepartmentsEdit: FC<IProps> = ({ segment, onSave }) => {
  const { t } = useTranslation();
  const { values } = useFormikContext<UpdateUserSegmentInput>();

  const { department_ids } = segment;
  const mutationOptions = useUpdateSegment();
  const { mutate, isLoading } = useUpdateUserSegmentMutation({
    onSuccess: onSave,
    ...mutationOptions,
  });

  function handleChange(departmentIds: Array<ClientDepartmentFragment['id']>) {
    mutate({
      data: {
        ...values,
        department_ids: departmentIds,
      },
    });
  }

  return (
    <Grid container>
      <Grid item xs={3}>
        <Grid container alignItems="center">
          <Grid item>
            <Typography variant="subtitle2">{t('common:department_plural')}</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={9}>
        <DepartmentPicker
          selectedDepartmentIds={department_ids}
          onDepartmentChange={handleChange}
          saving={isLoading}
        />
      </Grid>
    </Grid>
  );
};

export default DepartmentsEdit;
